import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import LogoNoBg from "../../assets/logo-no-bg.png";
import { notification } from "antd";
import axios from "axios";

import { createTicket } from "../../Utils/apis";

export default function ContactUs() {
  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const openCustomNotification = (tag, msg) => {
    const args = {
      message: tag,
      description: msg,
      duration: 10,
    };
    notification.open(args);
  };

  const submitData = () => {
    console.log(title);
    console.log(email);
    console.log(phone);
    console.log(message);
    axios({
      method: "post",
      url: createTicket,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        title: title,
        email: email,
        description: message,
        issue_type: "spinwheel-issues",
      },
    })
      .then(function (result) {
        if ((result.status = 200)) {
          console.log("success");
          openCustomNotification("Success", "message sent successfuly , wewould get back to you soon");
        }
      })
      .catch((error) => {
        console.log(error);
        console.log("Error");
        openCustomNotification("Error", "message not sent successfuly");
      });
  };

  return (
    <div>
      <Navbar />
      <h3 className="text-center mt-3 text-underline text-white">Contact Us</h3>
      <div class="container contact-form">
        <div class="contact-image">
          <img
            src="https://cdn5.vectorstock.com/i/thumb-large/98/94/fortune-wheel-game-logo-casino-slot-machine-vector-31539894.jpg"
            alt="rocket_contact"
          />
        </div>
        <form method="post">
          <h3 className="text-white">Drop Us a Message</h3>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <input
                  type="text"
                  name="txtName"
                  class="form-control"
                  placeholder="Title *"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div class="form-group">
                <input
                  type="text"
                  name="txtEmail"
                  class="form-control"
                  placeholder="Your Email *"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div class="form-group">
                <input
                  type="number"
                  name="txtPhone"
                  class="form-control"
                  placeholder="Your Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div class="form-group">
                <input
                  type="submit"
                  name="btnSubmit"
                  class="btnContact"
                  value="Send Message"
                  onClick={(e) => {
                    e.preventDefault();
                    submitData();
                  }}
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <textarea
                  name="txtMsg"
                  className="form-control"
                  placeholder="Your Message *"
                  style={{ width: "100%", height: 150 }}
                  defaultValue={""}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
